export default {
  setBankAccounts(state, bankAccounts) {
    state.bankAccounts = bankAccounts;
  },
  setBankAccount(state, bankAccount) {
    state.bankAccount = bankAccount;
  },
  setBanksList(state, banksList) {
    state.banksList = banksList;
  },
  setBalance(state, balance) {
    state.balance = balance;
  },
  setTransactions(state, transactions) {
    state.transactions = transactions;
  },
  setWithdraws(state, withdraws) {
    state.withdraws = withdraws;
  },
  setPagination(state, pagination) {
    state.pagination = pagination;
  }
};
